export default function detectModulesSupportedInWorker() {
    if (typeof window === "undefined" || window.Worker == null) {
        return false;
    }
    let modulesSupported = false;
    try {
        new Worker("data:", {
            get type() {
                modulesSupported = true;
                return "module";
            }
        }).terminate();
    }
    catch (_) {
        modulesSupported = false;
    }
    return modulesSupported;
}
